import { ClipboardCheckIcon, ClipboardListIcon, FlaskConicalIcon, LibraryIcon, SearchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: "150 Attività in Classe di Meteorologia e Scienze dell'Atmosfera",
    description: 'Attività pronte organizzate per tema, con obiettivo, durata, materiali e domande guida.',
    icon: ClipboardListIcon,
  },
  {
    number: '2',
    title: 'Kit Completo di Valutazione in Meteorologia',
    description: 'Verifiche per unità, soluzioni complete, griglie e rubriche di valutazione.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: '100 Casi di Studio su Meteo e Atmosfera',
    description: 'Situazioni meteo realistiche da analizzare in classe con spiegazione scientifica.',
    icon: SearchIcon,
  },
  {
    number: '4',
    title: '100 Esperimenti, Indagini e Sfide di Meteorologia',
    description: 'Esperimenti semplici e sicuri con materiali comuni, procedura e spiegazione.',
    icon: FlaskConicalIcon,
  },
  {
    number: '5',
    title: 'Biblioteca di Risorse per la Programmazione delle Lezioni di Meteorologia',
    description: 'Programmazione annuale e per unità, sequenze di lezioni pronte, schede e glossario.',
    icon: LibraryIcon,
  },
];
